import React from "react";
import "./HintComponent.css";

function HintComponent({ setOpenModal, country }) {
  return (
    <div className="modalBackground">
      <div className="modalContainer">
        <div className="title">
          <h1>{country.hint}</h1>
        </div>
        <div className="footer">
          <button
            onClick={() => {
              setOpenModal(false);
            }}
            id="okayBtn"
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}

export default HintComponent;